import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { color, font } from 'src/shared/styles/variables';

import { CoachIntroWrapper } from '../components/CoachIntroWrapper';
import { CommonStepButtons } from '../components/CommonStepButtons';
import { ScreenWrapper } from '../components/ScreenWrapper';
import { IntakeFormProps, IntakeFormTestID } from '../models/intakeForm';

const IntroTextWrapper = styled('div')({
    width: 540,
    margin: 32,
    padding: 28,
    border: `2px solid ${color.catskillWhite}`,
    borderRadius: '0.4rem',
});

const ButtonContainer = styled('div')({
    width: 540,
});

const IntroGreeting = styled('p')(
    {
        lineHeight: '24px',
        color: color.ebonyClay,
        marginBottom: 24,
    },
    font.heavy(font.size.large),
);

const IntroPara = styled('p')(
    {
        lineHeight: '24px',
        color: color.blueBayoux,
        marginBottom: 24,
    },
    font.medium(font.size.medium),
);

export const IntakeIntroScreen: React.FC<IntakeFormProps> = props => {
    const {
        coachAvatar,
        coachFirstName,
        coachLastName,
        coachCredentials,
        userFirstName,
        onAbandonClick,
        toggleCoachMoreInfo,
        skipQuestion,
    } = props;
    const { t } = useTranslation();

    return (
        <ScreenWrapper data-testid={IntakeFormTestID.IntroScreen}>
            <CoachIntroWrapper
                withInfo
                onInfoClick={toggleCoachMoreInfo}
                coachAvatar={coachAvatar}
                coachFirstName={coachFirstName}
                coachLastName={coachLastName}
                coachCredentials={coachCredentials}
            />
            <IntroTextWrapper>
                <IntroGreeting>{t('intakeForms:intro.greeting', { userFirstName })}</IntroGreeting>
                <IntroPara>{t('intakeForms:intro.im_your_coach', { coachFirstName })}</IntroPara>
                <IntroPara>{t('intakeForms:intro.set_up_for_success')}</IntroPara>
                <IntroPara>{t('intakeForms:intro.encourage_to_share')}</IntroPara>
            </IntroTextWrapper>
            <ButtonContainer>
                <CommonStepButtons
                    skipText={null}
                    forwardText={t('intakeForms:intro.begin_form')}
                    backText={t('intakeForms:intro.complete_later')}
                    onForwardClick={skipQuestion}
                    onBackClick={() => onAbandonClick('')}
                    onSkipClick={() => null}
                />
            </ButtonContainer>
        </ScreenWrapper>
    );
};
